import { useEffect, useState } from "react";

/**
 * `false` on the first render (SSR and the first client paint), `true` after commit + `useEffect`.
 * Use to defer DOM that depends on persisted Redux, cookies, Monarch, or other browser-only data
 * so the initial tree matches static export HTML before hydration completes.
 */
export function useClientMounted(): boolean {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);
  return mounted;
}
